import { axios } from "@/plugins/http-request.js";

const state = {
  countries: [],
};

const getters = {
  countries: (state) => state.countries,
};

const actions = {
  getCountries() {
    return axios.get("/api/countries").then((res) => res.data);
  },
  getCountriesSettings() {
    return axios.get("/api/country_settings").then((res) => res.data);
  },
  getPincodeList(_, payload) {
    return axios
      .get(`/api/pincode-list/${payload.id}`, { params: payload })
      .then((res) => res.data);
  },
  getCountriesDatalist(_, id) {
    return axios
      .get(`/api/base-country/validation/list/${id}`)
      .then((res) => res.data);
  },
  updatcountryeetting(context, payload) {
    return axios
      .patch(`/api/countries_update_status/${payload.id}`, payload.data)
      .then((res) => res.data);
  },
  downloadPincodeSetting(context, payload) {
    return axios
      .post(`/api/pincode/download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  downloadAreaSetting(context, payload) {
    return axios
      .post(`/api/base-country-city-area/download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  uploadPincode(context, payload) {
    return axios.post(`/api/pincode/upload`, payload).then((res) => res.data);
  },
  uploadarea(context, payload) {
    return axios
      .post(`/api/base-country-city-area/upload`, payload)
      .then((res) => res.data);
  },
  uploadBaseCountry(context, payload) {
    return axios
      .post(`/api/base-country-city/upload`, payload)
      .then((res) => res.data);
  },

  downloadBaseCountry(context, data) {
    return axios
      .post(
        `/api/base-country-city/download?status=${data.status}`,
        data.params,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },

  getCountriesFilter(context, payload) {
    return axios
      .get("/api/countries", { params: payload })
      .then((res) => res.data);
  },
  updateCountries(context, payload) {
    return axios
      .patch(`/api/countries_update_status/${payload.id}`, payload.data)
      .then((res) => res.data);
  },
  async getCountriesList(context, payload) {
    return await axios
      .get(`/api/carrier-country/${payload.id}`, {
        params: payload.option,
      })
      .then((res) => res.data);
  },
  downloadCountryList(context, payload) {
    return axios
      .post(`/api/carrier-country/download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  uploadCountryList(context, payload) {
    return axios
      .post(`/api/carrier-country/upload`, payload)
      .then((res) => res.data);
  },
  uploadrRsaCountry(context, payload) {
    return axios
      .post(`/api/rsa_carrier-country-city/upload`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  getCitiesList(context, payload) {
    return axios
      .get(`/api/carrier-cities/${payload.id}`, {
        params: payload.option,
      })
      .then((res) => res.data);
  },
  getAreaList(context, payload) {
    return axios
      .get(`/api/carrier-area/list/${payload.id}`, {
        params: payload.option,
      })
      .then((res) => res.data);
  },
  getpincodeList(context, payload) {
    return axios
      .get(`/api/carrier-pincode/list/${payload.id}`, {
        params: payload.option,
      })
      .then((res) => res.data);
  },
  downloadSampleRSAarea() {
    return axios
      .get(
        `/api/file_download?file_path=coverage/templates/rsa_carrier_area_compare.xlsx`,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  downloadCityList(context, payload) {
    return axios
      .post(`/api/carrier-country-city/download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  downloadAreaList(context, payload) {
    return axios
      .post(`/api/carrier-area/download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  downloadpincodeList(context, payload) {
    return axios
      .post(`/api/carrier-pincode/download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  uploadAreaList(context, payload) {
    return axios.post(`/api/carrier-area/upload`, payload).then((res) => res);
  },
  uploadpincodeList(context, payload) {
    return axios
      .post(`/api/carrier-pincode/upload`, payload)
      .then((res) => res);
  },
  uploadrRsaArea(context, payload) {
    return axios
      .post(
        `/api/rsa-carrier-area-compare/upload
      `,
        payload,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  uploadrRsaPincode(context, payload) {
    return axios
      .post(
        `/api/rsa-carrier-pincode-compare/upload
      `,
        payload,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },

  downloadSampleRSApincode() {
    return axios
      .get(
        `/api/file_download?file_path=coverage/templates/carrier-pincode-validate.xlsx`,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
  uploadCityList(context, payload) {
    return axios
      .post(`/api/carrier-country-city/upload`, payload)
      .then((res) => res.data);
  },
  getFulfillmentCountryList(context, id) {
    return axios
      .get(
        `/api/client-coverages/rsa_city_fulfillment?flag=html&client_id=${id}&extra_keys=1`
      )
      .then((res) => res.data);
  },
};

const mutations = {
  setCountries: (state, countries) => {
    state.countries = countries;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
